/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddTargetNoteMessageModel } from '../../models/add-target-note-message-model';
import { TargetNoteMessageModel } from '../../models/target-note-message-model';

export interface AddTargetNoteMessage$Params {
      body?: AddTargetNoteMessageModel
}

export function AddTargetNoteMessage(http: HttpClient, rootUrl: string, params?: AddTargetNoteMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<TargetNoteMessageModel>> {
  const rb = new RequestBuilder(rootUrl, AddTargetNoteMessage.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TargetNoteMessageModel>;
    })
  );
}

AddTargetNoteMessage.PATH = '/api/Staff/AddTargetNoteMessage';
